import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from '@/App/Router/routes';

/**
 * Devuelve una función para retroceder en la navegación. Si no existe una entrada previa válida en el historial,
 * redirige a la ruta de respaldo definida.
 * 
 * Si no se define una ruta de respaldo, se utiliza `ROUTES.HOME`.
 *
 * @returns {Function} `navigateBack` - Función para manejar el retroceso en la navegación.
 * -----------------------------------------------------------------------------------
 * La función de retorno utiliza los mismos parámetros que la función de retorno de `useNavigate`,
 * donde `fallbackTo` representa la ruta a la cual navegar si no es posible retroceder,
 * y `fallbackOptions` son las opciones de navegación para la ruta de respaldo.
 * 
 * @param {string | object} [fallbackTo=ROUTES.HOME] - La ruta a la cual navegar si no es posible retroceder.
 * @param {object} [fallbackOptions] - Opciones de navegación para la ruta de respaldo.
 */
const useNavigateBack = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateBack = (fallbackTo = ROUTES.HOME, fallbackOptions) => {
    if (location.key === 'default') {
      navigate(fallbackTo, fallbackOptions);
    } else {
      navigate(-1);
    }
  };

  return navigateBack;
};

export default useNavigateBack;